<template>
  <v-list dense>
    <v-row no-gutters>
      <v-col
        cols="6"
        v-for="(item, j) in subCatCalidad(calidadItem)"
        :key="`${j}-${item.Calidad}`"
      >
        <v-list-item>
          <v-list-item-content>
            <v-checkbox
              v-model="selectedFilterCalidad"
              :value="item.Calidad"
              :ripple="false"
              @click="setCalidad(selectedFilterCalidad)"
              color="#B05954"
              class="my-n2"
              hide-details
              :disabled="
                filterconsolidado.length === 0 ||
                subCatCalidad(calidadItem).length === 1
              "
              dense
            >
              <template v-slot:label>
                <span class="body-2">
                  {{ `${item.Calidad}` }}
                </span>
              </template>
            </v-checkbox>
          </v-list-item-content>
        </v-list-item>
      </v-col>
    </v-row>
  </v-list>
</template>

<script>
  import { mapState, mapGetters, mapMutations } from "vuex";

  export default {
    methods: {
      ...mapMutations(["GET_BUSCARCALIDAD", "setMenuDomoDeco", "clr_page"]),
      setCalidad(valor) {
        this.clr_page()
        this.GET_BUSCARCALIDAD(valor)
      },
    },
    props: {
      calidadItem: Array
    },
    computed: {
      ...mapGetters(["filterconsolidado"]),
      ...mapState(["ttArticuloAll", "filter"]),
      selectedFilterCalidad: {
        get() {
          return this.filter.calidad;
        },
        set(valor) {
          this.GET_BUSCARCALIDAD(valor);
        },
      },
      subCatCalidad: function () {
        return function (items) {
          const uniqueFormat = Array.from(
            new Set(items.map((item) => item.Calidad))
          ).map((Calidad) => {
            return items.find((id) => id.Calidad === Calidad);
          });

          return uniqueFormat;
        };
      },
    },
  };
</script>

<style></style>
